import React, { createContext, useState } from 'react';

import VccSeasonData from './VccSeasonData';

export const VccSeasonStateContext = createContext();

const VccSeasonContextProvider = ({ children }) => {
  const stateHook = useState(VccSeasonData.INITIAL_STATE);

  return (
    <VccSeasonStateContext.Provider value={stateHook}>
      {children}
    </VccSeasonStateContext.Provider>
  );
};

export default VccSeasonContextProvider;